import { CanActivateFn } from '@angular/router';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  const isModalRoute = route.outlet === 'modal';
  if (isModalRoute) {
    return true;
  }
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    switchMap((isAuth) => {
      if (isAuth) {
        return of(true);
      } else {
        return authService.login().pipe(
          tap((authUrl) => (window.location.href = authUrl)),
          switchMap(() => of(false))
        );
      }
    }),
    catchError(() => {
      router.navigate(['/login']);
      return of(false);
    })
  );
};
